import React, { useState } from "react";
import { useRefundSuccessPoller } from "@/hooks/useRefundSuccessPoller";
import { RefundWithItem } from "@/types/refundWithItem";
import RefundSuccessModal from "@/components/RefundSuccessModal";

type Props = {
  children: React.ReactNode;
};

const RefundSuccessPollerProvider: React.FC<Props> = ({ children }) => {
  const [currentRefund, setCurrentRefund] = useState<RefundWithItem | null>(
    null
  );

  const handleRefundSuccess = (refundWithItem: RefundWithItem) => {
    setCurrentRefund(refundWithItem);
  };

  const handleCloseSuccessModal = () => {
    setCurrentRefund(null);
  };

  useRefundSuccessPoller({
    onRefundSuccess: handleRefundSuccess,
    isModalVisible: !!currentRefund,
  });

  return (
    <>
      {children}
      {currentRefund && (
        <RefundSuccessModal
          visible={true}
          onClose={handleCloseSuccessModal}
          refundWithItem={currentRefund}
        />
      )}
    </>
  );
};

export default RefundSuccessPollerProvider;
